import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import useNotify from "../notification/use_notification";
import { login } from "../api";
import BaseInput from "../components/base_input";
import photo from "../res/foto9.jpg";

function Login() {
  const notify = useNotify();
  const navigate = useNavigate();
  const [state, setState] = useState({
    username: "",
    passkey: "",
  });
  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const mutation = useMutation({
    mutationFn: async (lvm) => {
      await login(lvm);
    },
    onError: (error) => notify.error(error),
    onSuccess: async () => {
      navigate("/");
    },
  });
  const handleSubmit = () => mutation.mutate(state);
  return (
    <div className="bg-blue-50 w-full h-full relative">
      <div className="bg-white sm:w-3/4 md:w-1/2 sm:h-1/2 m-auto absolute top-0 left-0 inset-0 p-4 rounded-lg shadow-md">
        <div className="text-lg font-medium py-2 px-1">Login</div>
        <img
          src={photo}
          alt="..."
          className="h-80 mx-auto my-4 rounded-lg shadow-sm"
        />
        <div className="flex flex-col gap-2">
          <BaseInput
            onChange={handleChange}
            value={state.username}
            name="username"
            type="username"
            label="Username"
            autocomplete="username"
          />
          <BaseInput
            onChange={handleChange}
            value={state.passkey}
            name="passkey"
            type="password"
            label="Password"
            autocomplete="password"
          />
          <button
            onClick={handleSubmit}
            type="submit"
            className="mt-4 py-1.5 px-2.5 text-white bg-indigo-600 hover:bg-indigo-400 rounded-md"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
export default Login;
